import { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import moment from "moment-timezone";
import httpApiCall from "../service/api.service";
import toastr from "../components/elements/toast";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from 'yup';
import { searchinput } from "../assets/assets";


const Callback = (props: any) => {
  const toastrService = new toastr(true);
  const answer = useSelector((state: any) => state?.APIData?.partnerData);
  const [note, setNote] = useState("");
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState();
  const [range, setRange] = useState();
  const [sppiner, setSppiner] = useState(false);
  const [data, setData] = useState({
    name: answer.partner_profile && answer.partner_profile[0] && answer.partner_profile[0]["partner_name"],
    phoneNumber: answer.partner_profile && answer.partner_profile[0] && answer?.partner_profile[0]["partner_mobile"],
    reason:"",
    msg:"",
    low:""
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Please enter name'),
    phoneNumber: Yup.string().required('Please enter phone number'),
    reason: Yup.string().required('Please select reason'),
    msg: Yup.string().required('Please enter message'),
    low: Yup.string().required('Please select priority'),
  });

  const selectReason = (reason: any) => {
    setReason(JSON.parse(reason));
  };
  const rightNow = new Date();
  const get = String(String(rightNow).split("(")[1]).split(")")[0];
  const getTimeZone = () => {
    let timeZone = "";
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + (time % 60)).slice(-2);
    if (time > 0) {
      timeZone = "-" + hours + minutes;
    } else {
      timeZone = "+" + hours + minutes;
    }
    return timeZone;
  };

  // const getTimeZoneName = () => {
  //   const zoneName = moment.tz.guess();
  //   return moment.tz(zoneName).zoneAbbr();
  // };

  const handleChange = (event:any) => {
    setRange(event.target.value)
  }

  const submitRequest = async (values:any) => {
    setSppiner(true)    
    // console.log(values,"submitRequest");
    
    let body = {
      access_token: answer?.partner_profile[0]["access_token"],
      partner_mobile: answer?.partner_profile[0]["partner_mobile"],
      partner_mobile_country_code:
        answer?.partner_profile[0]["partner_mobile_country_code"],
      message: note.trim(),
      call_req_date: new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
      call_req_time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      priority: range,
      csr_req_tz: getTimeZone(),
      csr_req_tz_name: get,
      reason_id: reason && reason["id"],
    };
    await httpApiCall({
      api: "add_csr_call_request_v2",
      type: "POST",
      body,
    }).then((data) => {
      setSppiner(false)
      if (data && !data.is_error) {
        // console.log(data);
        props.onHide();
        toastrService.showSuccess("Thank You! Our representative will contact you to handle your request shortly.")
      } else {
        if (data.override_text) {
          toastrService.showError(data.override_text);
        } else if (data.err) {
          toastrService.showError(data.err);
        }
      }
    }).catch((error) => {
      console.log("error");
    })
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-center"
        centered
        className="writetous"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h1>Request a Callback</h1>
            {/* <p>Please describe your query</p> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik initialValues={data} onSubmit={submitRequest} validationSchema={validationSchema}>
          {({setFieldValue})=> (
            <Form>
            <div className="form_data">
            <div>
              <label>Name</label>
              <Field
                className="form-control"
                type="text"
                disabled
                name="name"
              />
               <ErrorMessage name="name" component="small" className="text-danger m-2"  />
            </div>
            <div>
              <label>Phone Number</label>
              <div className="mobilecode">
                <p>{answer && answer.partner_profile && answer.partner_profile[0]["partner_mobile_country_code"]}</p>
                <Field
                  name="phoneNumber"
                  className="form-control"
                  type="number"
                  disabled
                  
                />
              </div>
               <ErrorMessage name="phoneNumber" component="small" className="text-danger m-2"  />
            </div>
            <div>
              <label>Select Reason</label>
              <div className="arrowSelectSmall">

              <Field
                name ='reason'
                as="select"
                className="form-control"
                onChange={(e:any) =>{ selectReason(e.target.value)
                  setFieldValue('reason', e.target.value);}}
              >
                <option value="">Please Select</option>
                {props.request &&
                  props.request.map((item: any) => (
                    <option key={item.id} value={JSON.stringify(item)}>
                      {item.reason}
                    </option>
                  ))}
              </Field>
              </div>
              <ErrorMessage name="reason" component="small" className="text-danger m-2"  />

            </div>
            <div className="textarea  form-group">
              <label htmlFor="msg">Message</label>
              <Field
                name="msg"
                as="textarea"
                placeholder="Enter your message here"
                onChange={(e:any) => {setNote(e.target.value);
                  setFieldValue('msg', e.target.value);}}
               
              />
              <ErrorMessage name="msg" component="small" className="text-danger m-2"  />

            </div>
            <div>
              <label>Priority</label>
              <div className="row priorty" onChange={handleChange}>
                <div className="col-lg-4 label_input">
                  <Field type="radio" name="low" id="priority1" value="1" />
                  <label htmlFor="priority1">Low</label>
                </div>
                <div className="col-lg-4 label_input">
                  <Field type="radio" name="low" id="priority2" value="2" />
                  <label htmlFor="priority2">Medium</label>
                </div>
                <div className="col-lg-4 label_input">
                  <Field type="radio" name="low" id="priority3" value="3" />
                  <label htmlFor="priority3">High</label>
                </div>
              </div>
              <ErrorMessage name="low" component="small" className="text-danger m-2"  />

            </div>
          </div>
          <Modal.Footer className="p-0">
          <Button type="submit">Submit {sppiner && (
                                              <Spinner
                                                className="ml-2"
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                            )}</Button>
        </Modal.Footer> 
            </Form>
          )}
          </Formik>
         
        </Modal.Body>
       
        <p className="note_submit">
          By submitting your information, you agree to our{" "}
          <Link to="https://credee.com/privacy-policy/" target="_blank">
            Privacy policy
          </Link>
          . By providing your contact information you are giving Credee
          Corporation (
          <Link to="https://credee.com/" target="_blank">
            credee.com
          </Link>
          ) permission to contact you about this and future offers using the
          information provided. You are providing Credee Corporation and third
          parties{show && (
            <span className="mb-0">consent to contact you through emails, calls, and text
            messages to your wireless telephone numbers. You understand contact
            may also include but is not limited to, using an automated dialing
            device and prerecorded messages.</span>
          )} 
          <div className="showmsg" onClick={() => setShow(!show)}> { show ? "Show Less" : " Show More"}</div>
        </p>
      </Modal>
    </div>
  );
};

export default Callback;
